import {
	createRouter,
	createWebHashHistory,
} from 'vue-router'
import store from '@/store'

const name = store.state.name;

const routes = [{
	path: '/',
	name: 'Index',
	component: () => import('@/views/Index.vue'),
	meta: {
		title: '首页'
	},
	children: [{
		path: '/',
		name: 'Home',
		component: () => import('@/views/Home.vue'),
		meta: {
			title: '首页'
		},
	}, {
		path: '/About',
		name: 'About',
		component: () => import('@/views/About.vue'),
		meta: {
			title: '关于我们'
		},
		children: [{
			path: 'GSJJ',
			name: 'GSJJ',
			component: () => import('@/views/About/GSJJ.vue'),
			meta: {
				title: '公司简介'
			},
		}, {
			path: 'FZLC',
			name: 'FZLC',
			component: () => import('@/views/About/FZLC.vue'),
			meta: {
				title: '发展历程'
			},
		}, {
			path: 'YWBK',
			name: 'YWBK',
			component: () => import('@/views/About/YWBK.vue'),
			meta: {
				title: '业务板块'
			},
		}, {
			path: 'ZZJG',
			name: 'ZZJG',
			component: () => import('@/views/About/ZZJG.vue'),
			meta: {
				title: '组织机构'
			},
		}, {
			path: 'FWLN',
			name: 'FWLN',
			component: () => import('@/views/About/FWLN.vue'),
			meta: {
				title: '服务理念'
			},
		}, {
			path: 'ZZRY',
			name: 'ZZRY',
			component: () => import('@/views/About/ZZRY.vue'),
			meta: {
				title: '资质荣誉'
			},
		}, {
			path: 'QYYS',
			name: 'QYYS',
			component: () => import('@/views/About/QYYS.vue'),
			meta: {
				title: '企业优势'
			},
		} ]
	}, {
		path: '/Business',
		name: 'Business',
		component: () => import('@/views/Business.vue'),
		meta: {
			title: '业务功能'
		},
		children: [{
			path: 'WLGHZX',
			name: 'WLGHZX',
			component: () => import('@/views/Business/WLGHZX.vue'),
			meta: {
				title: '物流规划咨询'
			}
		}, {
			path: 'ZNZBZZYJC',
			name: 'ZNZBZZYJC',
			component: () => import('@/views/Business/ZNZBZZYJC.vue'),
			meta: {
				title: '智能装备制造与集成'
			}
		}, {
			path: 'ZHWLRJKF',
			name: 'ZHWLRJKF',
			component: () => import('@/views/Business/ZHWLRJKF.vue'),
			meta: {
				title: '智慧物流软件开发'
			}
		}, {
			path: 'GYLFW',
			name: 'GYLFW',
			component: () => import('@/views/Business/GYLFW.vue'),
			meta: {
				title: '供应链服务'
			}
		}]
	}, {
		path: '/News',
		name: 'News',
		component: () => import('@/views/News.vue'),
		meta: {
			title: '公司动态'
		},
	}, {
		path: '/Case',
		name: 'Case',
		component: () => import('@/views/Case.vue'),
		meta: {
			title: '合作案例'
		},
	}, {
		path: '/Service',
		name: 'Service',
		component: () => import('@/views/Service.vue'),
		meta: {
			title: '服务流程'
		},
	}, {
		path: '/Us',
		name: 'Us',
		component: () => import('@/views/Us.vue'),
		meta: {
			title: '联系我们'
		},
	}, ]
}]

const router = createRouter({
	history: createWebHashHistory(),
	routes,
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition;
		}
		return {
			x: 0,
			y: 0
		}
	}
})

router.beforeEach((to, from, next) => {
	// console.log(to.name)
	if (!to.matched.length) {
		router.replace({
			path: '/'
		})
	}
	if (to.meta && to.meta.title) {
		document.title = name + ' - ' + to.meta.title;
	} else {
		document.title = name
	}
	next()
})

router.afterEach((to, from) => {
	// ...
	store.commit('set', {link: new Date().getTime()})
})

export default router
